var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('g',{attrs:{"fill":"none","stroke":"#11305e","stroke-width":"1"}},[_c('path',{attrs:{"d":"M12 11v4m2-2h-4m6-7V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2m10 0v14M6 6v14"}}),_c('rect',{attrs:{"width":"20","height":"14","x":"2","y":"6","rx":"2"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }